import Vue from 'vue'

export default (context, inject) => {
    const showSignupModal = function (options = {}) {
        context.$vfm.show({
            component: 'ModalSignup',
            bind: {
                options,
            },
        })
    }

    Vue.prototype.$showSignupModal = showSignupModal
    inject('showSignupModal', showSignupModal)
}
